import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "jr-w-full jr-h-screen jr-m-auto jr-fixed jr-top-0 jr-z-60 jr-flex jr-items-center" }
const _hoisted_2 = { class: "jr-relative jr-min-w-560 jr-max-w-560 jr-min-h-68 jr-bg-white jr-m-auto jr-p-4 jr-text-center" }
const _hoisted_3 = {
  key: 0,
  class: "jr-text-xl-1 jr-mt-6.5 jr-font-bold"
}
const _hoisted_4 = { class: "jr-mx-auto jr-mt-12 jr-w-full wordbreak-keepall" }
const _hoisted_5 = { class: "jr-absolute jr-left-0 jr-right-0 jr-bottom-0 jr-mb-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "jr-bg-black jr-w-full jr-h-screen jr-opacity-20 jr-z-50 jr-fixed" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("figure", null, [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_UIButton, {
                type: _ctx.ButtonType.classic,
                label: "閉じる",
                onClick: _ctx.onClose,
                class: "jr-py-2 jr-w-40 jr-rounded-md jr-text-center jr-text-sm jr-m-auto"
              }, null, 8, ["type", "onClick"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.show]
        ]),
        _hoisted_6
      ])
    ]),
    _: 1
  }))
}